import React, { useState, useEffect } from 'react';
import './CountdownTimer.css'; // We'll add styles here
function CountdownTimer() {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });


    useEffect(() => {
        const targetDate = new Date('September 27, 2025'); // Replace with your target date
        const interval = setInterval(() => {
            const now = new Date();
            const timeLeft = targetDate.getTime() - now.getTime();

            setDays(Math.floor(timeLeft / (1000 * 60 * 60 * 24)));
            setHours(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            setMinutes(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)));
            setSeconds(Math.floor((timeLeft % (1000 * 60)) / 1000));
        }, 1000);
        setTimeLeft({
            days:0,
            hours:0,
            minutes:0,
            seconds: 0,
          });
        return () => clearInterval(interval);
    }, [days, hours, minutes, seconds]);

    return (
        <div className="countdown-grid">
        {Object.entries(timeLeft).map(([unit, value]) => (
          <div key={unit} className="countdown-box">
            <span className="countdown-value">{String(value).padStart(2, '0')}</span>
            <span className="countdown-label">{unit.toUpperCase()}</span>
          </div>
        ))}
      </div>

    );
}

export default CountdownTimer
